import NpoDashboard from '@/components/npos/Dashboard'
import NpoAccount from '@/components/npos/account/Account'
import NpoRefMerchants from '@/components/npos/RefMerchants'
import NpoDonations from '@/components/npos/Donations'
import NpoDonationDetails from '@/components/npos/DonationDetails'
import NpoHelp from '@/components/npos/Help'

export default [
  {
    path: '/npos/dashboard',
    name: 'NpoDashboard',
    meta: {
      accessLevels: ['npo-admin']
    },
    component: NpoDashboard
  },
  {
    path: '/npos/account',
    name: 'NpoProfile',
    meta: {
      accessLevels: ['npo-admin']
    },
    component: NpoAccount
  },
  {
    path: '/npos/merchants',
    name: 'NpoRefMerchants',
    meta: {
      accessLevels: ['npo-admin']
    },
    component: NpoRefMerchants
  },
  {
    path: '/npos/donations',
    name: 'NpoDonations',
    meta: {
      accessLevels: ['npo-admin']
    },
    component: NpoDonations
  },
  {
    path: '/npos/donations/:id',
    props: true,
    name: 'NpoDonationDetails',
    meta: {
      accessLevels: ['npo-admin']
    },
    component: NpoDonationDetails
  },
  {
    path: '/npos/help',
    name: 'NpoHelp',
    meta: {
      accessLevels: ['npo-admin']
    },
    component: NpoHelp
  }
]



// WEBPACK FOOTER //
// ./src/router/npo.js